module.exports = __webpack_public_path__ + "static/image/history/pc/202602_1.ver2_0_2.jpg?97fc87b6";